import type { MarketIdentifiers } from '$lib/types/market';
import { Interface } from 'ethers/lib/utils.js';
import type { IConnectorReturnData } from '../types';
import abi from '../abi';
import { SYNTHETIX_PERP_CONNECTOR } from './constants';
import { MARKET_ADDRESES } from '../addresses';

export const updateKeeperFee = (): IConnectorReturnData => {
	const synthethixInterface = new Interface(abi.scWalletSynthetixPerpV2);
	return {
		_target: SYNTHETIX_PERP_CONNECTOR,
		_callData: synthethixInterface.encodeFunctionData('updateKeeperFee')
	};
};
